import { render, staticRenderFns } from "./ModalPenalidade.vue?vue&type=template&id=6dee03f1"
import script from "./ModalPenalidade.vue?vue&type=script&lang=js"
export * from "./ModalPenalidade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports